<script>
  let getDate = new Date();
</script>

<div class="footer">
  <footer>
    &#169; {getDate.getFullYear()} - A fairly useful thing built by
    <a href="https://whatspauldoing.com">Paul Mackenzie</a> - Quotes via
    <a href="https://quotable.io">quotable.io</a>
  </footer>
</div>

<style lang="scss">
  .footer {
    display: flex;
    width: 90vw;
    height: 10vh;
    align-items: center;
    justify-content: center;
    footer {
      opacity: 0.5;
    }
    a {
      text-decoration: underline;
    }
  }
</style>
